import {useEffect} from "react";
import {Column} from "components";
import {Header, Table} from "./lib";
import {get} from "global/slices/credits/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import {initialState} from "global/slices/credits/initial-state";

interface CreditsProps {}

export const Credits: React.FC<CreditsProps> = () => {
  const dispatch = useAppDispatch();
  const {credits} = useAppSelector("credits");
  useEffect(() => {
    if (!credits["length"]) dispatch(get(initialState["pagination"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credits]);

  return (
    <Column>
      <Header />
      <Table />
    </Column>
  );
};
